<template>  
    <form class="ShoppingCartMobile form-wrapper" @submit.prevent="proceedPayment">
      <div class="m-0 p-0 form-wrapper-body">
      <h3>Invoice</h3>
      <div class="basket flex-grow-1">
        <div class="basket-header row mx-0">
          <div class="col-8"></div>
          <div class="col-4 second-section round-top-border align-items-center">
            <p class="basket-header-title">AMOUNT</p>
          </div>
        </div>
        <div class="basket-body row mx-0">
          <div class="row mx-0">
            <div
              class="col-8 fisrt-section"
              :title="invoiceData.activityName"
            >
              <span class="text-gray" :style="{ fontSize: '13px' }">
                Activity
              </span>
              <div class="cursor-pointer activity-name text-truncate">
                {{ invoiceData.activityName }}
              </div>
            </div>
            <template v-if="invoiceData.amount !== 0">
              <div :class="['col-4', 'pt-3', 'second-section', 'base-price']">
                <p class="mb-0">
                  {{ schoolCurrency | currencySign }} {{ invoiceData.amount | priceFormat }} <span v-if="showBillingRate">/ {{invoiceData.aftercareActivityDetails.billingRate | toCapitalize}}</span>
                </p>
              </div>
            </template>

            <template v-else>
              <div
                class="col-4 pt-3 text-green second-section d-flex justify-content-center align-items-end"
              >
                FREE
              </div>
            </template>
          </div>

          <div class="row mx-0" v-if="invoiceData.addons">
            <div class="col-8 pl-0">
              <div class="addon-chip" v-for="addon in invoiceData.addons">
                <span>Addon: {{ schoolCurrency | currencySign }}{{ addon.amount }}</span>
              </div>
            </div>
            <div
              class="col-4 second-section round-top-border align-items-center"
            ></div>
          </div>

          <div class="row mx-0">
            <div
              class="col-8 fisrt-section"
              :title="
                invoiceData.child.firstName + ' ' + invoiceData.child.lastName
              "
            >
              <span class="text-gray mb-2" :style="{ fontSize: '13px' }"
                >Child</span
              >
              <div class="d-flex align-items-center">
                <!-- <div class="w-auto">
                  <logo :logo-url="invoiceData.child.childPhoto"></logo>
                </div> -->
                <div class="name text-truncate">
                  {{
                    invoiceData.child.firstName +
                      " " +
                      invoiceData.child.lastName
                  }}
                </div>
              </div>
            </div>
            <div class="col-4 second-section"></div>
          </div>
          <template v-if="invoiceData.aftercareActivityDetails && invoiceData.aftercareActivityDetails.daysOfWeek">
                        <div class="row mx-0">
                            <div class="col-8 fisrt-section">
                                <p class="text-gray mb-2"
                                      :style="{ fontSize:'13px' }">
                                    Days
                                </p>
                                <p class="name">
                                    <span v-for="(day, index) in invoiceData.aftercareActivityDetails.daysOfWeek"
                                          :key="index"
                                          class="day">
                                        {{day.dayOfWeek | toCapitalize}}
                                    </span>
                                </p>
                            </div>

                            <div class="col-4 second-section"></div>
                        </div>
          </template>
          <template v-if="invoiceData.aftercareDropInDetails && invoiceData.aftercareDropInDetails.dropInDates">
                        <div class="row mx-0">
                            <div class="col-8 fisrt-section">
                                <p class="text-gray mb-2"
                                      :style="{ fontSize:'13px' }">
                                    Dates
                                </p>
                                <p class="date-wrapper">
                                    <span v-for="(date, index) in invoiceData.aftercareDropInDetails.dropInDates"
                                          :key="index"
                                          class="date-chip">
                                        {{date.date }}
                                    </span>
                                </p>
                            </div>

                            <div class="col-4 second-section"></div>
                        </div>
          </template>
        </div>
        <div class="basket-footer">

          <template v-if="!(isScheduledAttendance || isActualAttendance)">
            <div class="row mx-0">
              <p class="col-8 fisrt-section-result">Total:</p>
              <template>
                <p class="col-4 py-2 mb-0 second-section text-right">
                  {{ schoolCurrency | currencySign }} {{ invoiceData.totalActivityPrice }}
                </p>
              </template>
            </div>
          </template>
          
          <template v-if="showTotalAddons">
            <div class="row mx-0">
              <p class="col-8 fisrt-section-result ">Total Addons:</p>
              <template>
                <p class="col-4 py-2 mb-0 second-section">
                  {{ schoolCurrency | currencySign }} {{ invoiceData.totalAddon }}
                </p>
              </template>
            </div>
          </template>

          <template v-if="invoiceData.discounts.length > 0">
            <template v-for="discount in discounts">
            <div class="row mx-0">
              <p class="col-8 py-2 mb-0 fisrt-section-result">{{ discount.label }}:</p>
              <template>
                <p
                  :class="[
                    'col-4',
                    'py-2',
                    'mb-0',
                    'second-section',
                    'red-color',
                  ]"
                >
                <span v-if="isActualAttendance">-{{ discount.value }}%</span>
                <span v-else-if="isScheduledAttendance">-{{ schoolCurrency | currencySign }} {{ discount.amount }} /{{ isDay }}</span>
                <span v-else>
                    <span v-if="discount.amount > 0"
                    >- {{ schoolCurrency | currencySign }} {{ discount.amount | priceFormat }}</span>
                    <span v-else>{{ schoolCurrency | currencySign }} 0</span>
                </span>
                </p>
              </template>
            </div>
          </template>
          </template>
          <template v-else>
            <div class="row mx-0">
            <p class="col-8 fisrt-section-result ">Discount:</p>
            <p
                :class="[
                  'col-4',
                  'py-2',
                  'mb-0',
                  'second-section',
                ]"
              >
                <span>{{ schoolCurrency | currencySign }} 0</span>
              </p>
              </div>
          </template>

          <div class="row mx-0">
            <p class="col-8 fisrt-section-result ">Coupon:</p>
            <template v-if="invoiceData.coupon">
              <p
                :class="[
                  'col-4',
                  'py-2',
                  'mb-0',
                  'second-section',
                  'red-color',
                ]"
              >
              <span v-if="isActualAttendance || isScheduledAttendance">
                 <span v-if="invoiceData.coupon.couponType === 'FIXED_AMOUNT'">-{{ schoolCurrency | currencySign }} {{ invoiceData.coupon.value | priceFormat }} </span> 
                 <span  v-if="invoiceData.coupon.couponType === 'PERCENTAGE'">-{{ invoiceData.coupon.amount | priceFormat }}%</span>
              </span>
              <span v-else>
                <span v-if="invoiceData.coupon.value > 0"
                   >- {{ schoolCurrency | currencySign }}{{ invoiceData.coupon.value | priceFormat }}</span>
                   <span v-else>{{ schoolCurrency | currencySign }}  0</span>
              </span>
              </p>
            </template>
            <template v-else>
              <p class="col-4 py-2 mb-0 second-section">
                {{ schoolCurrency | currencySign }} 0
              </p>
            </template>
          </div>
          <div class="row mx-0">
            <p
              class="col-8 fisrt-section-result total-bold"
            >
              Billed Today:
            </p>
            <p
              class="col-4 py-2 mb-0 second-section round-bottom-border total-bold "
            >
              {{ schoolCurrency | currencySign }}
              <span v-if="invoiceData.total > 0">{{ invoiceData.total | priceFormat }}</span>
              <span v-else>0</span>
            </p>
          </div>
        </div>

        <div class="promo">
          <p class="text-gray mb-1">Apply promo code</p>
          <app-input
            type="text"
            id="promocode"
            placeholder="Enter promotional code"
            v-model="couponCode"
            blue-button
            :show-button="!!couponCode"
            :style="{ width: '100%' }"
            :append="{
              text: 'Apply',
              width: 80,
              fontSize: 18,
              callback: applyPromocode,
            }"
          >
          </app-input>
        </div>
      </div>
      
      <div class="p-3">
        <checkbox
          checkbox-id="agree"
          :blue-color="true"
          v-bind:checked.sync="checked"
        >
          I agree to all {{ schoolName }} policies
        </checkbox>
      </div>
    </div>
    <div class="form-wrapper-footer">
      <button
        class="primary-btn btn-center"
        :disabled="!checked || isLoading"
        v-spinner="isLoading"
      >
        Submit
      </button>
    </div>
    </form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as ChargeTypes from "@/constants/charge-types";

export default {
  name: "PayNowInvoiceModal",

  components: {
    Checkbox: () =>
      import(
        /* webpackChunkName: "shopping-cart" */ "@/components/controls/Checkbox"
      ),
    AppInput: () => import("@/components/controls/AppInput"),
  },
  data() {
    return {
      checked: false,
      isLoading: false,
      couponCode: "",
    };
  },
  computed: {
    ...mapGetters([
      "invoiceData",
      "schoolCurrency",
      "schoolName",
      "priceFormat",
      "currencySign",
    ]),
    showTotalAddons() {
      if (!this.invoiceData.addons) {
        return false;
      }
      if (this.invoiceData.addons.length == 1) {
        return false;
      }
      if (this.invoiceData.addons.length > 1) {
        return true;
      }
    },
    showBillingRate() {
                return this.invoiceData.aftercareActivityDetails  && this.invoiceData.aftercareActivityDetails.billingRate && this.invoiceData.aftercareActivityDetails.billingRate !== 'FIXED';
    },
    isActualAttendance() {
      return this.invoiceData.aftercareActivityDetails && this.invoiceData.aftercareActivityDetails.chargeType === ChargeTypes.ATTENDANCE;
    },
    isScheduledAttendance() {
      return this.invoiceData.aftercareActivityDetails 
      && (this.invoiceData.aftercareActivityDetails.chargeType === ChargeTypes.SCHEDULED)
      && (this.invoiceData.aftercareActivityDetails.billingRate !== 'FIXED')
      && (this.invoiceData.billingType !== 'SESSION');
    },
    isDay(){
    if(this.invoiceData.aftercareActivityDetails && this.invoiceData.aftercareActivityDetails.billingRate === 'DAY'){
      return "Day";
    }
    if(this.invoiceData.aftercareActivityDetails && this.invoiceData.aftercareActivityDetails.billingRate === 'HOUR') {
      return "Hour";
    } 
    else {
      return false;
    }
    },  
    discounts() {
      const discountLabelMap = {
        "EARLY_BIRD": "Early Bird Discount",
        "MULTI_CHILD": "Multi Child Discount",
        "MULTI_PROGRAM": "Multi Program Discount",
        "MULTI_DAY": "Multi Day Discount",
      };
      return this.invoiceData.discounts.map((discount) => {
        return {
          ...discount,
          label: discountLabelMap[discount.type]
        };
      }
      );
    },
  },
  methods: {
    ...mapActions(["confirmPayment", "applyCoupon"]),
    async proceedPayment() {
      this.isLoading = true;
      await this.confirmPayment(this.invoiceData.paymentId);
      this.isLoading = false;
    },
    async applyPromocode() {
      await this.applyCoupon({
        coupon: this.couponCode,
        paymentId: this.invoiceData.paymentId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors.scss";

.form-wrapper-footer {
  button {
    width: 50%;
  }
}


h3 {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    color: #19181c;
    margin-bottom: 36px;
}

.basket {
  &-header {
    padding: 0 25px;
    font-weight: 500;

    &-title {
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 0;
      font-size: 14px;
      color: $WarmGrey;
    }
  }
  &-body {
    padding: 0 14px;
    border-top: 2px solid rgba(233, 237, 240, 0.65);
    border-bottom: 2px solid rgba(233, 237, 240, 0.65);
    display: flex;
    flex-direction: column;
  }
  &-footer {
    padding: 0 25px;
  }
}

.base-price {
  text-align: end;
  display: inherit;
}

.second-section {
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  justify-content: center;
  background-color: $ComplementaryBackgroundLightGrey;
}

.red-color {
  color: $SimplyAfterSchoolLightRed;
}

.promo {
  margin-top: 20px;
  padding: 0 25px;
  display: flex;
  flex-direction: column;
  align-items: start;
  font-size: 14px;
}

.name {
  width: 164px;
  min-width: 160px;
  word-break: break-word;
  @media screen and (max-width: 568px) {
    width: 130px;
  }
  @media screen and (max-width: 480px) {
    width: 100px;
    margin-left: 5px;
  }
}

.day:not(:last-child) {
  &::after {
    content: ",";
  }
}

.activity-name {
  width: 200px;
  word-break: break-word;
  @media screen and (max-width: 568px) {
    width: 180px;
  }
  @media screen and (max-width: 480px) {
    width: 160px;
  }
}
.addon-chip {
  background-color: $ComplementaryBackgroundLightGrey;
  padding: 5px 10px;
  margin: 5px 0;
  border-radius: 15px;
  font-size: 14px;
  color: $Dark;
  width: fit-content;
}
.date-chip {
  background-color: $ComplementaryBackgroundLightGrey;
  padding: 5px 10px;
  border-radius: 15px;
  font-size: 14px;
  color: $Dark;
  width: fit-content;  
}
.date-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 3px;
}
.fisrt-section {        
  padding-bottom: 0.5rem;    
  padding-bottom: 1rem;      
  padding-left: 0;           
  display: flex;             
  flex-direction: column;    
  align-items: flex-start; 
  cursor: pointer; 
}
.fisrt-section-result {
  padding-top: 0.5rem;      
  padding-bottom: 0.5rem;
  margin-bottom: 0;          
  text-align: right;  
}
.total-bold {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/PayNowInvoiceModal.vue